import TutorialBase from "components/documentation/tutorials/tutorials.client.base"
import { Component } from "vue-property-decorator"

@Component
export default class TutorialWeb extends TutorialBase {
    public toggleFullscreen(): void {
        this.isFullscreen = !this.isFullscreen
    }
}
